import { faker } from "@faker-js/faker";



export default class PasswordGenerator
{

     

    static makePassPhrase(minPhraseLength=3, maxPhraseLength=4, separator="-", includeNumbers=false, includeUppercase = false)
    {
        //var seg1 = faker.word.adjective({length: {min: 5, max: 12}});
        var words = faker.word.words({count: {min:minPhraseLength, max:maxPhraseLength}});
        var wordSegs = words.split(" ");
        var result = wordSegs.join(separator);
        return result;
    }

}